import React from "react";

import {
  Button,
  Flex,
  Heading,
  Image,
  useMediaQuery,
  Box,
  Spinner
} from "@chakra-ui/react";

import api from "services/api";
import "./style.scss";
import {useWindowSize} from '../../utils/util-react';
import { useCustomToast } from "hooks/useToast";
import ErrorMessage from './components/error-message';
import ResgateProcess from './components/resgate-process'
import {ResgateProps} from './dominio'
import { v4 as uuidv4 } from 'uuid';

const ResgatePixPage = (props:any) => {

    const [isMobileSize] = useMediaQuery("(max-width: 992px)");
    const size = useWindowSize();
    const { getToast } = useCustomToast();

    const [resgateBanner, setResgateBanner] = React.useState<any>({});
    const [sucessoBanner, setSucessoBanner] = React.useState<any>({});

    const [pageState, setPageState] = React.useState<ResgateProps>(
        {
            saldo: 0, 
            processando: false, 
            retSaldo: false, 
            errorSaldo: false, 
            step: 1,
            resgateMinimo: 40,
            taxaConversao: 0.70,
            resgatePontos: undefined,
            resgateValor: undefined,
            chave: '',
            codigoConfirmacao: '',
            resgateRef: uuidv4(),
            bancoDestino: '',
            nomeTitular: '',
            resgateProcessoId: undefined,
            mensagemSucesso: 'Resgate registrado com sucesso',
            mensagemConfirmacao: 'Você receberá um código por SMS para confirmar o resgate!',
            tipoChavePix: '',
            mensagemBloqueioResgate: ''
        });

    React.useEffect(() => {
        const obterSaldo = async () => {
            if (pageState.processando === true)
                return;

            setPageState({...pageState, processando: true});
        try {
            const { data } = await api.get("/motorDePontos/saldoPontos");
            if (data && data.pontos !== undefined) {
                // Saldo atual: [{pageState.saldo} Ponto(s)] , valor inferior ao minimo
                let mensagemBloqueioResgate = data.mensagemBloqueioResgate === null ? undefined : data.mensagemBloqueioResgate;
                if (data.pontos < data.resgateMinimo && !data.mensagemBloqueioResgate) {
                    mensagemBloqueioResgate = `Saldo atual: [${data.pontos} Ponto(s)] , valor inferior ao minimo`;
                }
                setPageState({...pageState, saldo: data.pontos, mensagemBloqueioResgate: data.mensagemBloqueioResgate, resgateMinimo: data.resgateMinimo, taxaConversao: data.taxaConversao, retSaldo: true, processando: false, errorSaldo: false});
            }
            else {
                setPageState({...pageState, saldo: undefined, retSaldo: true, processando: false, errorSaldo: true});
            }
            } catch (error) {
                setPageState({...pageState, saldo: undefined, retSaldo: true, processando: false, errorSaldo: true});
            }
        }

        const obterBanners = async (id) => {
            /*
            10	Site-Resgate-Pix
            11	Site-Resgate-Pix-Error
            12	Site-Resgate-Pix-Sucesso
            */
            try {
                const {status, data} = await api.get(`/banner/bannerPagina/ListarPorPagina?paginaId=${id}`);
                if (status === 200 && data.length > 0) {
                    if (id === 10)
                        setResgateBanner(data[0].banner);
                    else if (id === 12)
                        setSucessoBanner(data[0].banner);
                }
                
            } catch (error) {
                
            }
        }

        if (resgateBanner.caminho === undefined) {
            obterBanners(10);
        }

        if (sucessoBanner.caminho === undefined) {
            obterBanners(12);
        }

        if (pageState.retSaldo === false) {
            obterSaldo();
        }

        
    }, []);

    const indexPg = !pageState.retSaldo
    ? 0
    : pageState.retSaldo && (pageState.errorSaldo === true || pageState.saldo === undefined)
      ? 1
      : Number(pageState.saldo) < Number(pageState.resgateMinimo)
        ? 2
        : 3;

    return (
        <>
        <div className="resgate_main">
            <div className="resgate_main_space"></div>
            <div className="resgate_main_content">
                {indexPg === 0 && 
                <Flex
                    margin="0px auto"
                    justifyContent="center"
                    marginBottom="auto"
                    marginTop={20}
                    height="100vh">
                    <Spinner size="xl" color="#009D57" />
                </Flex>}
                {indexPg === 1 && <ErrorMessage >Falha ao obter seu saldo, não é possivel realizar resgate, tente mais tarde</ErrorMessage>}
                {indexPg === 2 && <ErrorMessage >{pageState.mensagemBloqueioResgate}</ErrorMessage>}
                {indexPg === 3 && <ResgateProcess 
                                    pageState={pageState} 
                                    setPageState={setPageState} 
                                    resgateBanner={resgateBanner}  
                                    sucessoBanner={sucessoBanner}
                                  />}
            </div>
            <div className="resgate_main_space"></div>
        </div>
        </>
    );

}

export default ResgatePixPage;

